import React from 'react'

const Offline = () => (
  <div className="error"><span>STREAM OFFLINE</span></div>
)

Offline.propTypes = {}

export default Offline
